import styled, { css } from "styled-components/macro";

export const Container = styled.div`
  background: #008037;
  position: fixed;
  top: 80px;
  z-index: 99;
  min-height: 100vh;
  width: 200px;
  transition: all 0.3s ease;

  @media (min-width: 800px) {
    width: 200px;
  }

  ${({ isMenuMinimized }) =>
    isMenuMinimized &&
    css`
      width: 0px;
      overflow: hidden;
    `}
`;

export const Logo = styled.div`
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #d7f0db;
  transition: all 0.3s ease;

  img {
    height: 65px;
  }

  h1 {
    color: #fff;
    font-size: 30px;
  }

  @media (max-width: 800px) {
    ${({ isMenuMinimized }) =>
      isMenuMinimized &&
      css`
        width: 0px;
        overflow: hidden;
      `}
  }
`;

export const Menu = styled.ul`
  margin-top: 15px !important;
  position: relative;
  transition: all 0.15s ease;
  display: flex;
  flex-direction: column;
  align-items: center;

  li {
    width: 90%;
    display: flex;
    border-radius: 50px;
    flex-direction: row;
    margin-bottom: 10px;
    color: #fff;
    background-color: #40964e;
    svg {
      width: 25px;
    }

    a {
      cursor: pointer;
      min-height: 40px;
      width: 100%;
      padding: 0 5px 0 18px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      font-weight: 600;
    }

    &:hover {
      background: #d7f0db;
      color: #000;
    }

    span {
      display: flex;
      margin-left: 10px;
      flex: 1;
      font-size: 13px;
    }
  }
`;

export const Close = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  background: #008037;
  display: none;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;

  @media (max-width: 800px) {
    display: flex;
  }
`;
